<a
  class="text-decoration-none text-primary"
  href="javascript:void(0)"
  data-bs-toggle="modal"
  [attr.data-bs-target]="'#lotInfoModal_' + lotId"
  (click)="openModal()"
>
  <ng-content></ng-content>
</a>

<ng-template #lotInfoModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between d-flex pt-4">
      <h2 class="modal-title">Lot Information</h2>

      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>

    <div class="modal-body pb-3">
      <!-- @if (selectedLotInfo?.buyerName || selectedLotInfo?.buyerEmail) {
        <div class="d-flex gap-3 align-items-center bg-body-tertiary p-3 rounded-4 mb-3">
          <ul class="list-unstyled m-0">
            <li>
              <span class="user-38">{{
                ((selectedLotInfo?.buyerName?.split(' ')?.[0] || '')[0] || '').toUpperCase() +
                  ((selectedLotInfo?.buyerName?.split(' ')?.[1] || '')[0] || '').toUpperCase()
              }}</span>
            </li>
          </ul>
          <div class="d-flex flex-column">
            <span class="fs-20 fw-500">
              {{ selectedLotInfo?.buyerName ? (selectedLotInfo?.buyerName | titlecase) : '-' }}
              <span class="badge bg-primary fs-14 fw-400 rounded-3 ms-2">Buyer</span>
            </span>
            <span class="fs-14">
              @if (selectedLotInfo?.buyerEmail) {
                <i class="text-muted bi bi-envelope fs-14 me-1"></i>
                <a class="text-decoration-none text-muted" href="mailto:{{ selectedLotInfo?.buyerEmail }}">{{
                  selectedLotInfo?.buyerEmail || '-'
                }}</a>
              }
              @if (selectedLotInfo?.buyerPhone) {
                <i class="text-muted bi bi-telephone fs-14 mx-2"></i>
                <a class="text-decoration-none text-muted" href="tel:{{ selectedLotInfo?.buyerPhone }}">{{
                  selectedLotInfo?.buyerPhone || '-'
                }}</a>
              }
            </span>
          </div>
        </div>
      } -->

      <div class="row gy-3 gx-3 fs-14">
        <div class="col-md-6">
          <span class="fw-500 d-block">Lot No:</span>
          {{ selectedLotInfo?.lotNo || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">Project Code:</span>
          {{ selectedLotInfo?.projectCode || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">Lot Type:</span>
          {{ selectedLotInfo?.lotTypeName || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">Lot Description:</span>
          {{ selectedLotInfo?.descr || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">City:</span>
          {{ selectedLotInfo?.address?.cityName || selectedLotInfo?.address?.city?.cityName || '-' }}
        </div>

        <div class="col-md-6">
          <span class="fw-500 d-block">War Ref No:</span>
          {{ selectedLotInfo?.warRefNo || '-' }}
        </div>
        <div class="col-md-6">
          <span class="fw-500 d-block">Applicable Models:</span>
          @for (model of selectedLotInfo?.models; track model.id) {
            {{ model.modelName }}
            <!-- @if (index !== selectedLotInfo?.models.length - 1) {
              ,&nbsp;&nbsp;
            } -->
          }
        </div>

        <div class="col-md-6">
          <span class="fw-500 d-block">Lot Premium Amount:</span>
          {{ selectedLotInfo?.lotPremiumAmount || '-' }}
        </div>
      </div>

      @if (selectedLotInfo?.lotFolderId) {
        <hr class="my-3 text-gray-300" />
        <h5 class="text-black fw-500 mb-2 fs-18">Other Information</h5>
        <div class="col-md-6 cursor-pointer">
          <a
            class="fw-500 btn btn-outline-primary d-inline-flex btn-h45 cursor-pointer"
            [href]="'/all-files/' + selectedLotInfo?.lotFolderId"
            target="_blank"
          >
            <i class="bi bi-file-earmark-text"></i>View Docs <i class="bi fs-12 bi-box-arrow-up-right"></i
          ></a>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" (click)="modal.dismiss('Cross click')" class="btn btn-secondary">Close</button>
    </div>
  </div>
</ng-template>
